import React from "react";
import {Link} from "gatsby";
import InfoCard from "./bootstrap/infoCard";
import ContactCard from "./bootstrap/contactCard";
import {root, window} from "window-or-global";

const compliances = [
   {
    id: 1,
    title: "Terms and Conditions",
    links: [
      {
        id: "1a",
        label: "Terms and Conditions",
        url: "https://cdn.vostro.cloud/managed-wifi/General-Terms-%26-Conditions.pdf"
      },
      {
        id: "1b",
        label: "Critical Information Summary",
        url: ""
      },
      {
        id: "1c",
        label: "Acceptance Use Policy",
        url: "https://cdn.vostro.cloud/managed-wifi/Acceptable-Use-Policy.pdf"
      }
    ]
   },
   {
    id: 2,
    title: "Complaints Handling",
    links: [
      {
        id: "2a",
        label: "Complaints Handling Policy",
        url: "https://files.superloop.com/terms/SL-Residential-Complaints-Handling.pdf"
      },
    ]
   },
   {
    id: 3,
    title: "Payment Assistance Summary",
    links: [
      {
        id: "3a",
        label: "Payment Assistance Summary",
        url: ""
      },
      {
        id: "3b",
        label: "Payment Assistance Policy",
        url: "https://files.superloop.com/terms/Superloop-Payment-Assistance-Policy.pdf"
      }
    ]
   },
   {
    id: 4,
    title: "Online Safety",
    links: [
      {
        id: "4a",
        label: "Online Safety",
        url: "/esafety"
      }
    ]
   },
   {
    id: 5,
    title: "Privacy Policy",
    links: [
      {
        id: "5a",
        label: "Privacy Policy",
        url: "https://files.superloop.com/terms/SL-Residential-privacy-policy.pdf" 
      }
    ]
   }
];

const contacts = [
  {
    id: 1,
    title: "Contact Us",
    platforms: [
      {
        id: "1a",
        label: "Open Chat",
        icon: <i className="fas fa-comment"></i>,
        openContact: () => root.zE("messenger", "open"),
      },
      {
        id: "1b",
        label: "1300 262 047",
        icon: <i className="fas fa-phone"></i>,
        openContact: () => window.open('tel:1300262047'),
      },
      {
        id: "1c",
        label: "smart.help@superloop.com",
        icon: <i className="fas fa-envelope"></i>,
        openContact: () => window.open('mailto:smart.help@superloop.com'),
      },
    ]
  }
];


const ComplianceComponent = () => {
  return(
    <div className="compliances-container">
      <Link to="/" className="back-home">
        <i className="fa fa-caret-left" /><span>{" Back to Home"}</span>
      </Link>

      <div className="compliance-section">
        <h2>{"Terms, Conditions, and Policies"}</h2>

        <div className="compliance-index-container">
          {contacts.map(contact => {
            return(
              <ContactCard
                key={contact.id}
                title={contact.title}
                platforms={contact.platforms}
              />
            )
          })}
          {compliances.map(compliance => {
            return(
              <InfoCard
                key={compliance.id}
                title={compliance.title}
                links={compliance.links}
              />
            )})}
        </div>
      </div>
    </div>
  )
};

export default ComplianceComponent;
